import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControlLabel,
  Modal,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ActionButton from '../../../components/ActionButton';

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalPaper: {
    width: 540,
    padding: theme.spacing(3, 4),
    outline: 'none',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  title: {
    fontSize: 28,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  textfieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  formField: {
    marginTop: theme.spacing(2),
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
}));

const NuovaCategoriaControlloModal = ({ open, onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [isQuantitative, setIsQuantitative] = useState(true);
  const [unitOfMeasure, setUnitOfMeasure] = useState('');
  const [isDecimal, setIsDecimal] = useState(false);
  const [errors, setErrors] = useState({
    name: '',
    unitOfMeasure: '',
  });

  const classes = useStyles();

  const resetState = () => {
    setName('');
    setIsQuantitative(true);
    setUnitOfMeasure('');
    setIsDecimal(false);
    setErrors({ name: '', unitOfMeasure: '' });
  };

  const handleSave = () => {
    const newErrors = {
      name: '',
      unitOfMeasure: '',
    };
    let hasError = false;

    if (!name.trim()) {
      newErrors.name = 'Il nome della categoria è obbligatorio';
      hasError = true;
    }

    if (isQuantitative && !unitOfMeasure.trim()) {
      newErrors.unitOfMeasure =
        "L'unità di misura è obbligatoria per controlli quantitativi";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    onCreate({
      nome: name.trim(),
      unitaMisura: isQuantitative ? unitOfMeasure.trim() : '',
      tipoControllo: !isQuantitative
        ? 'BOOLEANO'
        : isDecimal
          ? 'DECIMALE'
          : 'INTERO',
    });

    resetState();
    onClose();
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} className={classes.modalRoot}>
      <Paper className={classes.modalPaper}>
        <Typography variant="h5" className={classes.title}>
          Nuova categoria
        </Typography>
        <div className={classes.textfieldWrapper}>
          <TextField
            id="nuova-categoria-nome"
            className={classes.formField}
            label="Nome categoria"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            required
            error={!!errors.name}
            helperText={errors.name}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isQuantitative}
                onChange={(e) => setIsQuantitative(e.target.checked)}
              />
            }
            label="Controllo quantitativo"
          />
        </div>
        {isQuantitative && (
          <div>
            <TextField
              id="nuova-categoria-unita-misura"
              className={classes.formField}
              label="Unità di misura"
              value={unitOfMeasure}
              onChange={(e) => setUnitOfMeasure(e.target.value)}
              fullWidth
              error={!!errors.unitOfMeasure}
              helperText={errors.unitOfMeasure}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={isDecimal}
                  onChange={(e) => setIsDecimal(e.target.checked)}
                />
              }
              label="Valori decimali"
            />
          </div>
        )}

        <div className={classes.buttonGroup}>
          <ActionButton secondaryButton label="Annulla" onClick={handleClose} />
          <ActionButton label="Salva" onClick={handleSave} />
        </div>
      </Paper>
    </Modal>
  );
};

NuovaCategoriaControlloModal.propTypes = {
  onCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default NuovaCategoriaControlloModal;
